import { gql } from '@apollo/client';

export const GET_PASSAGE_PLANS = gql`
  query GetPassagePlans($startAt: String, $endAt: String, $kindId: ID) {
    getPassagePlans(startAt: $startAt, endAt: $endAt, kindId: $kindId) {
      id
      fetchedAt
      lastUpdatedAt
      nextUpdateAt
      passagePlans {
        id
        direction
        enterAt
        viaWaypoint
        withPilot
        status
        ship {
          id
          name
          length
          tonnage
          huge
          kind {
            id
            name
            iconUrl
          }
          flagNation {
            id
            name
            abbreviation
            imageUrl
          }
        }
        destination {
          id
          name
        }
      }
    }
  }
`;

export const GET_SHIP = gql`
  query GetShip($id: ID!, $first: Int, $after: String) {
    getShip(id: $id) {
      id
      name
      length
      tonnage
      huge
      createdAt
      updatedAt
      kind {
        id
        name
        iconUrl
      }
      flagNation {
        id
        name
        abbreviation
        imageUrl
      }
      passagePlans(first: $first, after: $after) {
        nodes {
          id
          direction
          enterAt
          viaWaypoint
          withPilot
          status
          createdAt
          updatedAt
          destination {
            id
            name
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }
`;

export const GET_PASSAGE_PLAN = gql`
  query GetPassagePlan($id: ID!) {
    getPassagePlan(id: $id) {
      id
      direction
      enterAt
      viaWaypoint
      withPilot
      status
      createdAt
      updatedAt
      ship {
        id
        name
        length
        tonnage
        huge
        kind {
          id
          name
          iconUrl
        }
        flagNation {
          id
          name
          abbreviation
          imageUrl
        }
      }
      destination {
        id
        name
      }
    }
  }
`;

export const GET_SHIPS = gql`
  query GetShips(
    $flagNationId: ID
    $huge: Boolean
    $kindId: ID
    $lengthMax: Int
    $lengthMin: Int
    $nameContains: String
    $tonnageMax: Int
    $tonnageMin: Int
    $first: Int
    $after: String
  ) {
    getShips(
      flagNationId: $flagNationId
      huge: $huge
      kindId: $kindId
      lengthMax: $lengthMax
      lengthMin: $lengthMin
      nameContains: $nameContains
      tonnageMax: $tonnageMax
      tonnageMin: $tonnageMin
      first: $first
      after: $after
    ) {
      nodes {
        id
        name
        length
        tonnage
        huge
        createdAt
        updatedAt
        kind {
          id
          name
          iconUrl
        }
        flagNation {
          id
          name
          abbreviation
          imageUrl
        }
        passagePlans {
          nodes {
            id
            direction
            enterAt
            viaWaypoint
            withPilot
            status
            destination {
              id
              name
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_DESTINATIONS = gql`
  query GetDestinations($nameContains: String) {
    getDestinations(nameContains: $nameContains) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

export const GET_FLAG_NATIONS = gql`
  query GetFlagNations($nameContains: String, $abbreviationContains: String) {
    getFlagNations(nameContains: $nameContains, abbreviationContains: $abbreviationContains) {
      id
      name
      abbreviation
      imageUrl
      createdAt
      updatedAt
    }
  }
`;

export const GET_KINDS = gql`
  query GetKinds($nameContains: String) {
    getKinds(nameContains: $nameContains) {
      id
      name
      iconUrl
      createdAt
      updatedAt
    }
  }
`;
